interface Highlight {
  title: string;
  body: string;
}

const HIGHLIGHTS: Highlight[] = [
  {
    title: "A spin for every listing",
    body: "A smooth 360 loop in MP4 and GIF, cropped square and vertical, ready for marketplace listings, TikTok and Instagram.",
  },
  {
    title: "Hero stills and ad sizes",
    body: "Clean white-background stills plus styled scenes, delivered in feed, story and square sizes so one render feeds every channel.",
  },
  {
    title: "Variants you can test",
    body: "Two backgrounds or colorways per campaign set, so you can run a real A/B test before you spend more on ads.",
  },
  {
    title: "Files you own",
    body: "You get the final images and video. Source files and model are available on request for an added fee.",
  },
];

export function Highlights() {
  return (
    <section className="t-highlights" data-section="highlights">
      <header className="t-highlights-head">
        <h2 className="t-section-title">What you get</h2>
        <p className="t-section-lead">
          Everything is rendered from a 3D model of your product, so every angle and size comes
          out consistent.
        </p>
      </header>
      <ol className="t-highlight-index">
        {HIGHLIGHTS.map((h, index) => (
          <li key={h.title} className="t-highlight-row">
            <span className="t-highlight-num" aria-hidden="true">
              {String(index + 1).padStart(2, "0")}
            </span>
            <div className="t-highlight-body">
              <h3>{h.title}</h3>
              <p>{h.body}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}
